/* tslint:disable */
/* eslint-disable */

/**
 * deliveryProviderPortal delivery-provider-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, type GeneratedHttpClientConstraints, type RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    AuthorizationDocumentType,
    BatchGetMetricRequest,
    BatchGetMetricResponse,
    BulkDeleteMenuEntityResponse,
    BulkDeleteMenuItemsRequest,
    BulkUpdateMenuEntityRequest,
    BulkUpdateMenuEntityResponse,
    BulkUploadMenuItemImagesFromCSVRequest,
    BulkUploadMenuItemImagesFromCSVResponse,
    CancelFutureMenuLinkByIdRequest,
    CancelProviderPortalOfflinePeriodRequest,
    CheckMenuFilesOcrStatusRequest,
    CheckMenuOcrStatusResponse,
    CopyLastPublishedMenuFromVendorRequest,
    CopyLastPublishedMenuFromVendorResponse,
    CreateDineInTableRequest,
    CreateDineInTableResponse,
    CreateDineOutOfferingRequest,
    CreateDineOutOfferingResponse,
    CreateMenuEntityRequest,
    CreateMenuEntityResponse,
    CreateNewMerchantVenueRequestBody,
    CreateNewMerchantVenueResponse,
    CreateProviderMenuTimetableRequest,
    CreateProviderMenuTimetableResponse,
    CreateProviderPortalOfflinePeriodRequest,
    CreateProviderPortalOfflinePeriodResponse,
    CreateProviderRatingDisputeRequest,
    CreateProviderRatingDisputeResponse,
    CreateRefundDisputeRequest,
    CreateRefundDisputeResponse,
    DeleteChildEntityRequest,
    DeleteDineInTableRequest,
    DeleteDineOutOfferingRequest,
    DeleteMenuItemRequest,
    DeleteProviderMenuTimetableRequest,
    DownloadProviderDraftMenusCSVRequest,
    DownloadProviderDraftMenusCSVResponse,
    DownloadProviderInvoiceFileResponse,
    DownloadProviderInvoiceRequest,
    DownloadProviderSalesReportRequest,
    DownloadProviderSalesReportResponse,
    EmptyMenuRequest,
    EmptyMenuResponse,
    EnsureDraftMenuRequest,
    FileResponse,
    FindRequestableIntegrationSystemTypesResponse,
    FlexibleMenuList,
    GenerateProviderDetailedReportRequest,
    GenerateProviderDetailedReportResponse,
    GetAvailableDynamicFieldsRequest,
    GetAvailableDynamicFieldsResponse,
    GetAvailableTagsForClientResponse,
    GetBusinessRegisterOptionsResponse,
    GetCampaignTagsConfigResponse,
    GetCampaignsPermissionsForProvidersRequestBody,
    GetCampaignsPermissionsForProvidersResponse,
    GetCommissionAndFeesOptionsApiResponse,
    GetCommunicationLanguageOptionsResponse,
    GetDeductionDetailsRequest,
    GetDeductionDetailsResponse,
    GetDeductionsPaginatedRequest,
    GetDeductionsPaginatedResponse,
    GetDetailedReportsListForAccountRequest,
    GetDetailedReportsListForAccountResponse,
    GetDetailedReportsStatusesRequest,
    GetDetailedReportsStatusesResponse,
    GetDineInTablesForProviderRequest,
    GetDineInTablesForProviderResponse,
    GetDineOutOfferingsResponse,
    GetDownloadLinkForDetailedReportRequest,
    GetDownloadLinkForDetailedReportResponse,
    GetDynamicFieldsValuesRequest,
    GetDynamicFieldsValuesResponse,
    GetLatestNMVOnboardingProviderForAccountResponse,
    GetLinkedProviderGenericQrCodesRequest,
    GetLinkedProviderGenericQrCodesResponse,
    GetLocationAvailabilitiesResponse,
    GetMenuChildEntitiesRequest,
    GetMenuEditorFeatureFlagsResponse,
    GetMenuEntitiesRequest,
    GetMenuEntitiesResponse,
    GetMenuEntitiesWithAgeRestrictionsResponse,
    GetMenuEntityRequest,
    GetMenuEntityResponse,
    GetMenuInfoRequest,
    GetMenuInfoResponse,
    GetMenuItemsForProviderActiveMenuRequest,
    GetMenuItemsForProviderActiveMenuResponse,
    GetMenuPreviewRequest,
    GetMenuPreviewResponse,
    GetMetricRequest,
    GetMetricResponse,
    GetMetricsThresholdRequest,
    GetMetricsThresholdResponse,
    GetOpenImprovementTrackEnrollmentsRequest,
    GetOpenImprovementTrackEnrollmentsResponse,
    GetOrderHistoryDetailsRequest,
    GetOrderHistoryDetailsResponse,
    GetOrderHistoryPagesRequest,
    GetOrderHistoryPagesResponse,
    GetOrderHistoryWithFeedbackPaginatedRequest,
    GetOrderHistoryWithFeedbackPaginatedResponse,
    GetPreselectedOptionsEnablementConfigResponse,
    GetProviderAvailabilityModeListRequest,
    GetProviderAvailabilityModeListResponse,
    GetProviderDetailsResponse,
    GetProviderInvoicesRequest,
    GetProviderInvoicesResponse,
    GetProviderMenuTimetableResponse,
    GetProviderMenuTimetablesResponse,
    GetProviderMenusResponse,
    GetProviderOfflineReasonBreakdownRequest,
    GetProviderOfflineReasonBreakdownResponse,
    GetProviderOnboardingDetailsResponse,
    GetProviderOverallRatingRequest,
    GetProviderOverallRatingResponse,
    GetProviderPortalOfflinePeriodsRequest,
    GetProviderPortalOfflinePeriodsResponse,
    GetProviderScheduleResponse,
    GetProviderStatisticsRequest,
    GetProviderStatisticsResponse,
    GetProviderWeeklyReportCsvRequest,
    GetProviderWeeklyReportListResponse,
    GetProviderWeeklyReportRequest,
    GetProviderWeeklyReportResponse,
    GetProvidersAIMenuTranslationsAccessRequest,
    GetProvidersAIMenuTranslationsAccessResponse,
    GetQrCodeUrlForProviderRequest,
    GetQrCodeUrlForProviderResponse,
    GetRefundDisputeReasonsResponse,
    GetRefundDisputesPaginatedResponse,
    GetSalesByProductRequest,
    GetSalesByProductResponse,
    GetShownCommissionAndFeesOptionsRequest,
    GetSupportCaseWidgetUrlRequest,
    GetSupportCaseWidgetUrlResponse,
    GetSupportUnreadCasesWithLastMessageRequest,
    GetSupportUnreadCasesWithLastMessageResponse,
    GetSupportWidgetMqttConnectionInfoRequest,
    GetSupportWidgetMqttConnectionInfoResponse,
    GetSupportWidgetUrlRequest,
    GetSupportWidgetUrlResponse,
    GetTargetingValuesForProviderRequest,
    GetTargetingValuesForProviderResponse,
    GetUserFeatureFlagsResponse,
    GetVendorProviderProviderAndMenuLinksResponse,
    GetVendorProvidersAndMenuLinksRequest,
    GetYourPromotionsMetricsRequest,
    GetYourPromotionsMetricsResponse,
    HideImprovementTrackEnrollmentRequest,
    IsMenuBulkUploadEnabledForProviderPortalAccountResponse,
    LinkQrCodeToProviderAndTableRequest,
    MenuEditorBaseRequest,
    MenuEntityImageRequest,
    MenuEntityImageResponse,
    MenuItemsBulkUpdateRequest,
    MenuItemsChildrenCountRequest,
    MenuItemsChildrenCountResponse,
    MenuManagementMenuResponse,
    MenuModifiedRequest,
    MenuModifiedResponse,
    OverwriteDraftMenuRequest,
    OverwriteDraftMenuResponse,
    ProviderAwareRequest,
    ProviderMenuLinksRequest,
    ProviderMenuLinksResponse,
    PublishDraftMenuRequest,
    PublishMenuToProvidersResponse,
    RePublishActiveMenuForProviderRequest,
    RePublishActiveMenuForProviderResponse,
    RemoveDineOutOfferingImageRequest,
    SessionAwareRequest,
    SetDynamicFieldsValuesRequest,
    SetFeedbackPortalRequest,
    SetFeedbackPortalResponse,
    ShouldGetFeedbackPortalRequest,
    ShouldGetFeedbackPortalResponse,
    SkipFeedbackPortalRequest,
    SkipFeedbackPortalResponse,
    StartSessionResponse,
    StoreImprovementTrackAnalyticsEventRequest,
    TrackDetailedReportsPageViewedRequest,
    UnlinkQrCodeToProviderAndTableRequest,
    UpdateDineInTableRequest,
    UpdateDineOutOfferingRequest,
    UpdateMenuEntityRequest,
    UpdateMenuEntityResponse,
    UpdateMenuItemsDisplayOrderRequest,
    UpdateProviderDetailsRequest,
    UpdateProviderMenuTimetableRequest,
    UpdateProviderOnboardingDetailsRequest,
    UpdateProviderScheduleRequest,
    UploadDineOutOfferingImageResponse,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.JWT;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}

export interface FindRequestableIntegrationsByCountryCodeRequest {
    country_code: string;
}
export interface GetDineOutOfferingsRequest {
    provider_id: number;
}
export interface GetMenuRequest {
    provider_id: number;
    menu_language: string;
}
export interface GetProviderDetailsRequest {
    provider_id: number;
}
export interface GetProviderMenuTimetableRequest {
    provider_id: number;
    timetable_id: number;
}
export interface GetProviderMenuTimetablesRequest {
    provider_id: number;
}
export interface GetProviderOnboardingDetailsRequest {
    provider_id: number;
}
export interface GetProviderScheduleRequest {
    provider_id: number;
}
export interface GetRefundDisputesPaginatedRequest {
    provider_id: number;
    requested_start_timestamp: number;
    requested_end_timestamp: number;
    page?: number;
    items_per_page: number;
}
export interface MenuDishImageUploadMultipart {
    provider_id: number;
    session: string;
    skipOcr?: boolean;
    shouldLinkProvider?: boolean;
    name?: string;
}
export interface MenuStructureUploadMultipart {
    provider_id: number;
    session: string;
    skipOcr?: boolean;
    shouldLinkProvider?: boolean;
    name?: string;
}
export interface UpdateMenuEntityImageMultipart {
    provider_id: number;
    entity_id: string;
    menu_id: string;
}
export interface UploadDineOutOfferingImage2Multipart {
    provider_id: number;
    offering_id: number;
}
export interface UploadProviderAuthorizationDocument2Multipart {
    provider_id: number;
    document_type?: AuthorizationDocumentType;
}
export interface UploadProviderImage2Multipart {
    provider_id: number;
}


class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public bulkDeleteMenuItems = async (body: BulkDeleteMenuItemsRequest, opts?: TRequestOptions): Promise<BulkDeleteMenuEntityResponse>  => {
            return this.httpClient.sendRequest<BulkDeleteMenuEntityResponse>({
                path: '/deliveryProviderPortal/bulkDeleteMenuItems',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public bulkUpdateMenuEntity = async (body: BulkUpdateMenuEntityRequest, opts?: TRequestOptions): Promise<BulkUpdateMenuEntityResponse>  => {
            return this.httpClient.sendRequest<BulkUpdateMenuEntityResponse>({
                path: '/deliveryProviderPortal/bulkUpdateMenuEntity',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public bulkUploadMenuItemImagesFromCSV = async (body: BulkUploadMenuItemImagesFromCSVRequest, opts?: TRequestOptions): Promise<BulkUploadMenuItemImagesFromCSVResponse>  => {
            return this.httpClient.sendRequest<BulkUploadMenuItemImagesFromCSVResponse>({
                path: '/deliveryProviderPortal/bulkUploadMenuItemImagesFromCSV',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public cancelFutureMenuLinkById = async (body: CancelFutureMenuLinkByIdRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/cancelFutureMenuLinkById',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public cancelOfflinePeriod = async (body: CancelProviderPortalOfflinePeriodRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/cancelOfflinePeriod',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public checkMenuFilesOcrStatus = async (body: CheckMenuFilesOcrStatusRequest, opts?: TRequestOptions): Promise<CheckMenuOcrStatusResponse>  => {
            return this.httpClient.sendRequest<CheckMenuOcrStatusResponse>({
                path: '/deliveryProviderPortal/checkMenuFilesOcrStatus',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public copyLastPublishedMenuFromVendor = async (body: CopyLastPublishedMenuFromVendorRequest, opts?: TRequestOptions): Promise<CopyLastPublishedMenuFromVendorResponse>  => {
            return this.httpClient.sendRequest<CopyLastPublishedMenuFromVendorResponse>({
                path: '/deliveryProviderPortal/copyLastPublishedMenuFromVendor',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createDineOutOffering = async (body: CreateDineOutOfferingRequest, opts?: TRequestOptions): Promise<CreateDineOutOfferingResponse>  => {
            return this.httpClient.sendRequest<CreateDineOutOfferingResponse>({
                path: '/deliveryProviderPortal/createDineOutOffering',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createEmptyMenu = async (body: EmptyMenuRequest, opts?: TRequestOptions): Promise<EmptyMenuResponse>  => {
            return this.httpClient.sendRequest<EmptyMenuResponse>({
                path: '/deliveryProviderPortal/createEmptyMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createMenuEntity = async (body: CreateMenuEntityRequest, opts?: TRequestOptions): Promise<CreateMenuEntityResponse>  => {
            return this.httpClient.sendRequest<CreateMenuEntityResponse>({
                path: '/deliveryProviderPortal/createMenuEntity',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createNewMerchantVenue = async (body: CreateNewMerchantVenueRequestBody, opts?: TRequestOptions): Promise<CreateNewMerchantVenueResponse>  => {
            return this.httpClient.sendRequest<CreateNewMerchantVenueResponse>({
                path: '/deliveryProviderPortal/createNewMerchantVenue',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createOfflinePeriod = async (body: CreateProviderPortalOfflinePeriodRequest, opts?: TRequestOptions): Promise<CreateProviderPortalOfflinePeriodResponse>  => {
            return this.httpClient.sendRequest<CreateProviderPortalOfflinePeriodResponse>({
                path: '/deliveryProviderPortal/createOfflinePeriod',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createProviderMenuTimetable = async (body: CreateProviderMenuTimetableRequest, opts?: TRequestOptions): Promise<CreateProviderMenuTimetableResponse>  => {
            return this.httpClient.sendRequest<CreateProviderMenuTimetableResponse>({
                path: '/deliveryProviderPortal/createProviderMenuTimetable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createProviderRatingDispute = async (body: CreateProviderRatingDisputeRequest, opts?: TRequestOptions): Promise<CreateProviderRatingDisputeResponse>  => {
            return this.httpClient.sendRequest<CreateProviderRatingDisputeResponse>({
                path: '/deliveryProviderPortal/createProviderRatingDispute',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public createRefundDispute = async (body: CreateRefundDisputeRequest, opts?: TRequestOptions): Promise<CreateRefundDisputeResponse>  => {
            return this.httpClient.sendRequest<CreateRefundDisputeResponse>({
                path: '/deliveryProviderPortal/createRefundDispute',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deductionsGetDeductionDetails = async (body: GetDeductionDetailsRequest, opts?: TRequestOptions): Promise<GetDeductionDetailsResponse>  => {
            return this.httpClient.sendRequest<GetDeductionDetailsResponse>({
                path: '/deliveryProviderPortal/deductions/getDeductionDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deductionsGetDeductionHistory = async (body: GetDeductionsPaginatedRequest, opts?: TRequestOptions): Promise<GetDeductionsPaginatedResponse>  => {
            return this.httpClient.sendRequest<GetDeductionsPaginatedResponse>({
                path: '/deliveryProviderPortal/deductions/getDeductionHistory',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deleteChildEntity = async (body: DeleteChildEntityRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/deleteChildEntity',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deleteDineOutOffering = async (body: DeleteDineOutOfferingRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/deleteDineOutOffering',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deleteMenuEntityImages = async (body: MenuEntityImageRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/deleteMenuEntityImages',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deleteMenuItem = async (body: DeleteMenuItemRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/deleteMenuItem',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deleteProviderMenuTimetable = async (body: DeleteProviderMenuTimetableRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/deleteProviderMenuTimetable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public deliveryProviderGetOrderHistoryDetails = async (body: GetOrderHistoryDetailsRequest, opts?: TRequestOptions): Promise<GetOrderHistoryDetailsResponse>  => {
            return this.httpClient.sendRequest<GetOrderHistoryDetailsResponse>({
                path: '/deliveryProvider/getOrderHistoryDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInCreateTable = async (body: CreateDineInTableRequest, opts?: TRequestOptions): Promise<CreateDineInTableResponse>  => {
            return this.httpClient.sendRequest<CreateDineInTableResponse>({
                path: '/deliveryProviderPortal/dineIn/createTable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInDeleteTable = async (body: DeleteDineInTableRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/dineIn/deleteTable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInGetLinkedProviderGenericQrCodes = async (body: GetLinkedProviderGenericQrCodesRequest, opts?: TRequestOptions): Promise<GetLinkedProviderGenericQrCodesResponse>  => {
            return this.httpClient.sendRequest<GetLinkedProviderGenericQrCodesResponse>({
                path: '/deliveryProviderPortal/dineIn/getLinkedProviderGenericQrCodes',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInGetQrCodeUrlForProvider = async (body: GetQrCodeUrlForProviderRequest, opts?: TRequestOptions): Promise<GetQrCodeUrlForProviderResponse>  => {
            return this.httpClient.sendRequest<GetQrCodeUrlForProviderResponse>({
                path: '/deliveryProviderPortal/dineIn/getQrCodeUrlForProvider',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInGetTablesForProvider = async (body: GetDineInTablesForProviderRequest, opts?: TRequestOptions): Promise<GetDineInTablesForProviderResponse>  => {
            return this.httpClient.sendRequest<GetDineInTablesForProviderResponse>({
                path: '/deliveryProviderPortal/dineIn/getTablesForProvider',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInLinkQrCodeToProviderAndTable = async (body: LinkQrCodeToProviderAndTableRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/dineIn/linkQrCodeToProviderAndTable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInUnlinkQrCodeToProviderAndTable = async (body: UnlinkQrCodeToProviderAndTableRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/dineIn/unlinkQrCodeToProviderAndTable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public dineInUpdateTable = async (body: UpdateDineInTableRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/dineIn/updateTable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public downloadProviderDraftMenusCSV = async (body: DownloadProviderDraftMenusCSVRequest, opts?: TRequestOptions): Promise<DownloadProviderDraftMenusCSVResponse>  => {
            return this.httpClient.sendRequest<DownloadProviderDraftMenusCSVResponse>({
                path: '/deliveryProviderPortal/downloadProviderDraftMenusCSV',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public downloadProviderInvoice = async (body: DownloadProviderInvoiceRequest, opts?: TRequestOptions): Promise<DownloadProviderInvoiceFileResponse>  => {
            return this.httpClient.sendRequest<DownloadProviderInvoiceFileResponse>({
                path: '/deliveryProviderPortal/downloadProviderInvoice',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public downloadProviderSalesReport = async (body: DownloadProviderSalesReportRequest, opts?: TRequestOptions): Promise<DownloadProviderSalesReportResponse>  => {
            return this.httpClient.sendRequest<DownloadProviderSalesReportResponse>({
                path: '/deliveryProviderPortal/downloadProviderSalesReport',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public downloadProviderWeeklyReportCsv = async (body: GetProviderWeeklyReportCsvRequest, opts?: TRequestOptions): Promise<FileResponse>  => {
            return this.httpClient.sendRequest<FileResponse>({
                path: '/deliveryProviderPortal/downloadProviderWeeklyReportCsv',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public ensureDraftMenu = async (body: EnsureDraftMenuRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/ensureDraftMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public feedbackSetFeedback = async (body: SetFeedbackPortalRequest, opts?: TRequestOptions): Promise<SetFeedbackPortalResponse>  => {
            return this.httpClient.sendRequest<SetFeedbackPortalResponse>({
                path: '/deliveryProviderPortal/feedback/setFeedback',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public feedbackShouldGetFeedback = async (body: ShouldGetFeedbackPortalRequest, opts?: TRequestOptions): Promise<ShouldGetFeedbackPortalResponse>  => {
            return this.httpClient.sendRequest<ShouldGetFeedbackPortalResponse>({
                path: '/deliveryProviderPortal/feedback/shouldGetFeedback',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public feedbackSkipFeedback = async (body: SkipFeedbackPortalRequest, opts?: TRequestOptions): Promise<SkipFeedbackPortalResponse>  => {
            return this.httpClient.sendRequest<SkipFeedbackPortalResponse>({
                path: '/deliveryProviderPortal/feedback/skipFeedback',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public findRequestableIntegrationsByCountryCode = async (query: FindRequestableIntegrationsByCountryCodeRequest, opts?: TRequestOptions): Promise<FindRequestableIntegrationSystemTypesResponse>  => {
            return this.httpClient.sendRequest<FindRequestableIntegrationSystemTypesResponse>({
                path: '/deliveryProviderPortal/findRequestableIntegrationsByCountryCode',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public generateDetailedReport = async (body: GenerateProviderDetailedReportRequest, opts?: TRequestOptions): Promise<GenerateProviderDetailedReportResponse>  => {
            return this.httpClient.sendRequest<GenerateProviderDetailedReportResponse>({
                path: '/deliveryProviderPortal/generateDetailedReport',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getAvailableDynamicFields = async (body: GetAvailableDynamicFieldsRequest, opts?: TRequestOptions): Promise<GetAvailableDynamicFieldsResponse>  => {
            return this.httpClient.sendRequest<GetAvailableDynamicFieldsResponse>({
                path: '/deliveryProviderPortal/getAvailableDynamicFields',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getAvailableTagsForClient = async (body: MenuEditorBaseRequest, opts?: TRequestOptions): Promise<GetAvailableTagsForClientResponse>  => {
            return this.httpClient.sendRequest<GetAvailableTagsForClientResponse>({
                path: '/deliveryProviderPortal/getAvailableTagsForClient',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getCampaignTagsConfig = async (opts?: TRequestOptions): Promise<GetCampaignTagsConfigResponse>  => {
            return this.httpClient.sendRequest<GetCampaignTagsConfigResponse>({
                path: '/deliveryProviderPortal/getCampaignTagsConfig',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getCampaignsPermissionsForProviders = async (body: GetCampaignsPermissionsForProvidersRequestBody, opts?: TRequestOptions): Promise<GetCampaignsPermissionsForProvidersResponse>  => {
            return this.httpClient.sendRequest<GetCampaignsPermissionsForProvidersResponse>({
                path: '/deliveryProviderPortal/getCampaignsPermissionsForProviders',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getCommunicationLanguageOptions = async (opts?: TRequestOptions): Promise<GetCommunicationLanguageOptionsResponse>  => {
            return this.httpClient.sendRequest<GetCommunicationLanguageOptionsResponse>({
                path: '/deliveryProviderPortal/getCommunicationLanguageOptions',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getCurrentLocationAvailabilities = async (opts?: TRequestOptions): Promise<GetLocationAvailabilitiesResponse>  => {
            return this.httpClient.sendRequest<GetLocationAvailabilitiesResponse>({
                path: '/deliveryProviderPortal/getCurrentLocationAvailabilities',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getDetailedReportsListForAccount = async (body: GetDetailedReportsListForAccountRequest, opts?: TRequestOptions): Promise<GetDetailedReportsListForAccountResponse>  => {
            return this.httpClient.sendRequest<GetDetailedReportsListForAccountResponse>({
                path: '/deliveryProviderPortal/getDetailedReportsListForAccount',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getDetailedReportsStatuses = async (body: GetDetailedReportsStatusesRequest, opts?: TRequestOptions): Promise<GetDetailedReportsStatusesResponse>  => {
            return this.httpClient.sendRequest<GetDetailedReportsStatusesResponse>({
                path: '/deliveryProviderPortal/getDetailedReportsStatuses',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getDineOutOfferings = async (query: GetDineOutOfferingsRequest, opts?: TRequestOptions): Promise<GetDineOutOfferingsResponse>  => {
            return this.httpClient.sendRequest<GetDineOutOfferingsResponse>({
                path: '/deliveryProviderPortal/getDineOutOfferings',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getDownloadLinkForDetailedReport = async (body: GetDownloadLinkForDetailedReportRequest, opts?: TRequestOptions): Promise<GetDownloadLinkForDetailedReportResponse>  => {
            return this.httpClient.sendRequest<GetDownloadLinkForDetailedReportResponse>({
                path: '/deliveryProviderPortal/getDownloadLinkForDetailedReport',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getDynamicFieldsValues = async (body: GetDynamicFieldsValuesRequest, opts?: TRequestOptions): Promise<GetDynamicFieldsValuesResponse>  => {
            return this.httpClient.sendRequest<GetDynamicFieldsValuesResponse>({
                path: '/deliveryProviderPortal/getDynamicFieldsValues',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getLatestNMVOnboardingProviderForAccount = async (opts?: TRequestOptions): Promise<GetLatestNMVOnboardingProviderForAccountResponse | null>  => {
            return this.httpClient.sendRequest<GetLatestNMVOnboardingProviderForAccountResponse | null>({
                path: '/deliveryProviderPortal/getLatestNMVOnboardingProviderForAccount',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getMainEntryWidgetUrl = async (body: GetSupportWidgetUrlRequest, opts?: TRequestOptions): Promise<GetSupportWidgetUrlResponse>  => {
            return this.httpClient.sendRequest<GetSupportWidgetUrlResponse>({
                path: '/deliveryProviderPortal/getMainEntryWidgetUrl',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenu = async (query: GetMenuRequest, opts?: TRequestOptions): Promise<MenuManagementMenuResponse>  => {
            return this.httpClient.sendRequest<MenuManagementMenuResponse>({
                path: '/deliveryProviderPortal/getMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getMenuChildEntities = async (body: GetMenuChildEntitiesRequest, opts?: TRequestOptions): Promise<GetMenuEntitiesResponse>  => {
            return this.httpClient.sendRequest<GetMenuEntitiesResponse>({
                path: '/deliveryProviderPortal/getMenuChildEntities',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuEditorFeatureFlags = async (opts?: TRequestOptions): Promise<GetMenuEditorFeatureFlagsResponse>  => {
            return this.httpClient.sendRequest<GetMenuEditorFeatureFlagsResponse>({
                path: '/deliveryProviderPortal/getMenuEditorFeatureFlags',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getMenuEntities = async (body: GetMenuEntitiesRequest, opts?: TRequestOptions): Promise<GetMenuEntitiesResponse>  => {
            return this.httpClient.sendRequest<GetMenuEntitiesResponse>({
                path: '/deliveryProviderPortal/getMenuEntities',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuEntitiesWithAgeRestrictions = async (body: GetMenuEntitiesRequest, opts?: TRequestOptions): Promise<GetMenuEntitiesWithAgeRestrictionsResponse>  => {
            return this.httpClient.sendRequest<GetMenuEntitiesWithAgeRestrictionsResponse>({
                path: '/deliveryProviderPortal/getMenuEntitiesWithAgeRestrictions',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuEntity = async (body: GetMenuEntityRequest, opts?: TRequestOptions): Promise<GetMenuEntityResponse>  => {
            return this.httpClient.sendRequest<GetMenuEntityResponse>({
                path: '/deliveryProviderPortal/getMenuEntity',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuInfo = async (body: GetMenuInfoRequest, opts?: TRequestOptions): Promise<GetMenuInfoResponse>  => {
            return this.httpClient.sendRequest<GetMenuInfoResponse>({
                path: '/deliveryProviderPortal/getMenuInfo',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuItemsChildrenNumber = async (body: MenuItemsChildrenCountRequest, opts?: TRequestOptions): Promise<MenuItemsChildrenCountResponse>  => {
            return this.httpClient.sendRequest<MenuItemsChildrenCountResponse>({
                path: '/deliveryProviderPortal/getMenuItemsChildrenNumber',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuItemsForProviderActiveMenu = async (body: GetMenuItemsForProviderActiveMenuRequest, opts?: TRequestOptions): Promise<GetMenuItemsForProviderActiveMenuResponse>  => {
            return this.httpClient.sendRequest<GetMenuItemsForProviderActiveMenuResponse>({
                path: '/deliveryProviderPortal/getMenuItemsForProviderActiveMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getMenuPreview = async (body: GetMenuPreviewRequest, opts?: TRequestOptions): Promise<GetMenuPreviewResponse>  => {
            return this.httpClient.sendRequest<GetMenuPreviewResponse>({
                path: '/deliveryProviderPortal/getMenuPreview',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getOfflinePeriods = async (body: GetProviderPortalOfflinePeriodsRequest, opts?: TRequestOptions): Promise<GetProviderPortalOfflinePeriodsResponse>  => {
            return this.httpClient.sendRequest<GetProviderPortalOfflinePeriodsResponse>({
                path: '/deliveryProviderPortal/getOfflinePeriods',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getOpenImprovementTrackEnrollments = async (body: GetOpenImprovementTrackEnrollmentsRequest, opts?: TRequestOptions): Promise<GetOpenImprovementTrackEnrollmentsResponse>  => {
            return this.httpClient.sendRequest<GetOpenImprovementTrackEnrollmentsResponse>({
                path: '/deliveryProviderPortal/getOpenImprovementTrackEnrollments',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getOrderHistoryPages = async (body: GetOrderHistoryPagesRequest, opts?: TRequestOptions): Promise<GetOrderHistoryPagesResponse>  => {
            return this.httpClient.sendRequest<GetOrderHistoryPagesResponse>({
                path: '/deliveryProviderPortal/getOrderHistoryPages',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getOrderHistoryWithFeedbackPaginated = async (body: GetOrderHistoryWithFeedbackPaginatedRequest, opts?: TRequestOptions): Promise<GetOrderHistoryWithFeedbackPaginatedResponse>  => {
            return this.httpClient.sendRequest<GetOrderHistoryWithFeedbackPaginatedResponse>({
                path: '/deliveryProviderPortal/getOrderHistoryWithFeedbackPaginated',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getPreselectedOptionsEnablementConfig = async (opts?: TRequestOptions): Promise<GetPreselectedOptionsEnablementConfigResponse>  => {
            return this.httpClient.sendRequest<GetPreselectedOptionsEnablementConfigResponse>({
                path: '/deliveryProviderPortal/getPreselectedOptionsEnablementConfig',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getProviderAvailabilityModeList = async (body: GetProviderAvailabilityModeListRequest, opts?: TRequestOptions): Promise<GetProviderAvailabilityModeListResponse>  => {
            return this.httpClient.sendRequest<GetProviderAvailabilityModeListResponse>({
                path: '/deliveryProviderPortal/getProviderAvailabilityModeList',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderBusinessRegisterOptions = async (opts?: TRequestOptions): Promise<GetBusinessRegisterOptionsResponse>  => {
            return this.httpClient.sendRequest<GetBusinessRegisterOptionsResponse>({
                path: '/deliveryProviderPortal/getProviderBusinessRegisterOptions',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getProviderDetails = async (query: GetProviderDetailsRequest, opts?: TRequestOptions): Promise<GetProviderDetailsResponse>  => {
            return this.httpClient.sendRequest<GetProviderDetailsResponse>({
                path: '/deliveryProviderPortal/getProviderDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getProviderInvoices = async (body: GetProviderInvoicesRequest, opts?: TRequestOptions): Promise<GetProviderInvoicesResponse>  => {
            return this.httpClient.sendRequest<GetProviderInvoicesResponse>({
                path: '/deliveryProviderPortal/getProviderInvoices',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderMenuLinks = async (body: ProviderMenuLinksRequest, opts?: TRequestOptions): Promise<ProviderMenuLinksResponse>  => {
            return this.httpClient.sendRequest<ProviderMenuLinksResponse>({
                path: '/deliveryProviderPortal/getProviderMenuLinks',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderMenuTimetable = async (query: GetProviderMenuTimetableRequest, opts?: TRequestOptions): Promise<GetProviderMenuTimetableResponse>  => {
            return this.httpClient.sendRequest<GetProviderMenuTimetableResponse>({
                path: '/deliveryProviderPortal/getProviderMenuTimetable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getProviderMenuTimetables = async (query: GetProviderMenuTimetablesRequest, opts?: TRequestOptions): Promise<GetProviderMenuTimetablesResponse>  => {
            return this.httpClient.sendRequest<GetProviderMenuTimetablesResponse>({
                path: '/deliveryProviderPortal/getProviderMenuTimetables',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getProviderMenus = async (body: MenuEditorBaseRequest, opts?: TRequestOptions): Promise<GetProviderMenusResponse>  => {
            return this.httpClient.sendRequest<GetProviderMenusResponse>({
                path: '/deliveryProviderPortal/getProviderMenus',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderOfflineReasonBreakdown = async (body: GetProviderOfflineReasonBreakdownRequest, opts?: TRequestOptions): Promise<GetProviderOfflineReasonBreakdownResponse>  => {
            return this.httpClient.sendRequest<GetProviderOfflineReasonBreakdownResponse>({
                path: '/deliveryProviderPortal/getProviderOfflineReasonBreakdown',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderOnboardingDetails = async (query: GetProviderOnboardingDetailsRequest, opts?: TRequestOptions): Promise<GetProviderOnboardingDetailsResponse>  => {
            return this.httpClient.sendRequest<GetProviderOnboardingDetailsResponse>({
                path: '/deliveryProviderPortal/getProviderOnboardingDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getProviderOverallRating = async (body: GetProviderOverallRatingRequest, opts?: TRequestOptions): Promise<GetProviderOverallRatingResponse>  => {
            return this.httpClient.sendRequest<GetProviderOverallRatingResponse>({
                path: '/deliveryProviderPortal/getProviderOverallRating',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderSchedule = async (query: GetProviderScheduleRequest, opts?: TRequestOptions): Promise<GetProviderScheduleResponse>  => {
            return this.httpClient.sendRequest<GetProviderScheduleResponse>({
                path: '/deliveryProviderPortal/getProviderSchedule',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getProviderStatistics = async (body: GetProviderStatisticsRequest, opts?: TRequestOptions): Promise<GetProviderStatisticsResponse>  => {
            return this.httpClient.sendRequest<GetProviderStatisticsResponse>({
                path: '/deliveryProviderPortal/getProviderStatistics',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderWeeklyReport = async (body: GetProviderWeeklyReportRequest, opts?: TRequestOptions): Promise<GetProviderWeeklyReportResponse>  => {
            return this.httpClient.sendRequest<GetProviderWeeklyReportResponse>({
                path: '/deliveryProviderPortal/getProviderWeeklyReport',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderWeeklyReportList = async (body: object, opts?: TRequestOptions): Promise<GetProviderWeeklyReportListResponse>  => {
            return this.httpClient.sendRequest<GetProviderWeeklyReportListResponse>({
                path: '/deliveryProviderPortal/getProviderWeeklyReportList',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProvidersAIMenuTranslationsAccess = async (body: GetProvidersAIMenuTranslationsAccessRequest, opts?: TRequestOptions): Promise<GetProvidersAIMenuTranslationsAccessResponse>  => {
            return this.httpClient.sendRequest<GetProvidersAIMenuTranslationsAccessResponse>({
                path: '/deliveryProviderPortal/getProvidersAIMenuTranslationsAccess',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getRefundDisputeReasons = async (opts?: TRequestOptions): Promise<GetRefundDisputeReasonsResponse>  => {
            return this.httpClient.sendRequest<GetRefundDisputeReasonsResponse>({
                path: '/deliveryProviderPortal/getRefundDisputeReasons',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getRefundDisputesPaginated = async (query: GetRefundDisputesPaginatedRequest, opts?: TRequestOptions): Promise<GetRefundDisputesPaginatedResponse>  => {
            return this.httpClient.sendRequest<GetRefundDisputesPaginatedResponse>({
                path: '/deliveryProviderPortal/getRefundDisputesPaginated',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                query,
            }, opts);
        }
        public getShownCommissionAndFeesOptions = async (body: GetShownCommissionAndFeesOptionsRequest, opts?: TRequestOptions): Promise<GetCommissionAndFeesOptionsApiResponse>  => {
            return this.httpClient.sendRequest<GetCommissionAndFeesOptionsApiResponse>({
                path: '/deliveryProviderPortal/getShownCommissionAndFeesOptions',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getSupportCaseWidgetUrl = async (body: GetSupportCaseWidgetUrlRequest, opts?: TRequestOptions): Promise<GetSupportCaseWidgetUrlResponse>  => {
            return this.httpClient.sendRequest<GetSupportCaseWidgetUrlResponse>({
                path: '/deliveryProviderPortal/getSupportCaseWidgetUrl',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getSupportWidgetMqttConnectionInfo = async (body: GetSupportWidgetMqttConnectionInfoRequest, opts?: TRequestOptions): Promise<GetSupportWidgetMqttConnectionInfoResponse>  => {
            return this.httpClient.sendRequest<GetSupportWidgetMqttConnectionInfoResponse>({
                path: '/deliveryProviderPortal/getSupportWidgetMqttConnectionInfo',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getTargetingValuesForProvider = async (body: GetTargetingValuesForProviderRequest, opts?: TRequestOptions): Promise<GetTargetingValuesForProviderResponse>  => {
            return this.httpClient.sendRequest<GetTargetingValuesForProviderResponse>({
                path: '/deliveryProviderPortal/getTargetingValuesForProvider',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getUnreadCasesWithLastMessage = async (body: GetSupportUnreadCasesWithLastMessageRequest, opts?: TRequestOptions): Promise<GetSupportUnreadCasesWithLastMessageResponse>  => {
            return this.httpClient.sendRequest<GetSupportUnreadCasesWithLastMessageResponse>({
                path: '/deliveryProviderPortal/getUnreadCasesWithLastMessage',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getUserFeatureFlags = async (opts?: TRequestOptions): Promise<GetUserFeatureFlagsResponse>  => {
            return this.httpClient.sendRequest<GetUserFeatureFlagsResponse>({
                path: '/deliveryProviderPortal/getUserFeatureFlags',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public getVendorProviderAndMenuLinks = async (body: GetVendorProvidersAndMenuLinksRequest, opts?: TRequestOptions): Promise<GetVendorProviderProviderAndMenuLinksResponse>  => {
            return this.httpClient.sendRequest<GetVendorProviderProviderAndMenuLinksResponse>({
                path: '/deliveryProviderPortal/getVendorProviderAndMenuLinks',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getYourPromotionsMetrics = async (body: GetYourPromotionsMetricsRequest, opts?: TRequestOptions): Promise<GetYourPromotionsMetricsResponse>  => {
            return this.httpClient.sendRequest<GetYourPromotionsMetricsResponse>({
                path: '/deliveryProviderPortal/getYourPromotionsMetrics',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public hideImprovementTrackEnrollment = async (body: HideImprovementTrackEnrollmentRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/hideImprovementTrackEnrollment',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public isMenuBulkUploadEnabledForProviderPortalAccount = async (opts?: TRequestOptions): Promise<IsMenuBulkUploadEnabledForProviderPortalAccountResponse>  => {
            return this.httpClient.sendRequest<IsMenuBulkUploadEnabledForProviderPortalAccountResponse>({
                path: '/deliveryProviderPortal/isMenuBulkUploadEnabledForProviderPortalAccount',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.GET,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
            }, opts);
        }
        public isMenuModified = async (body: MenuModifiedRequest, opts?: TRequestOptions): Promise<MenuModifiedResponse>  => {
            return this.httpClient.sendRequest<MenuModifiedResponse>({
                path: '/deliveryProviderPortal/isMenuModified',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public menuDishImageFinishSession = async (body: SessionAwareRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/menuDishImage/finishSession',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public menuDishImageList = async (body: ProviderAwareRequest, opts?: TRequestOptions): Promise<FlexibleMenuList>  => {
            return this.httpClient.sendRequest<FlexibleMenuList>({
                path: '/deliveryProviderPortal/menuDishImage/list',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public menuDishImageReset = async (body: ProviderAwareRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/menuDishImage/reset',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public menuDishImageStartSession = async (body: ProviderAwareRequest, opts?: TRequestOptions): Promise<StartSessionResponse>  => {
            return this.httpClient.sendRequest<StartSessionResponse>({
                path: '/deliveryProviderPortal/menuDishImage/startSession',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public menuDishImageUpload = async (body: MenuDishImageUploadMultipart, files: Record<'file', File>, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/menuDishImage/upload',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                files,
            }, opts);
        }
        public menuItemsBulkUpdate = async (body: MenuItemsBulkUpdateRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/menuItemsBulkUpdate',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public menuStructureFinishSession = async (body: SessionAwareRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/menuStructure/finishSession',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public menuStructureList = async (body: ProviderAwareRequest, opts?: TRequestOptions): Promise<FlexibleMenuList>  => {
            return this.httpClient.sendRequest<FlexibleMenuList>({
                path: '/deliveryProviderPortal/menuStructure/list',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public menuStructureReset = async (body: ProviderAwareRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/menuStructure/reset',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public menuStructureStartSession = async (body: ProviderAwareRequest, opts?: TRequestOptions): Promise<StartSessionResponse>  => {
            return this.httpClient.sendRequest<StartSessionResponse>({
                path: '/deliveryProviderPortal/menuStructure/startSession',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public menuStructureUpload = async (body: MenuStructureUploadMultipart, files: Record<'file', File>, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/menuStructure/upload',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                files,
            }, opts);
        }
        public metricsBatchGet = async (body: BatchGetMetricRequest, opts?: TRequestOptions): Promise<BatchGetMetricResponse>  => {
            return this.httpClient.sendRequest<BatchGetMetricResponse>({
                path: '/deliveryProviderPortal/metrics/batchGet',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public metricsGet = async (body: GetMetricRequest, opts?: TRequestOptions): Promise<GetMetricResponse>  => {
            return this.httpClient.sendRequest<GetMetricResponse>({
                path: '/deliveryProviderPortal/metrics/get',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public metricsThresholdsGet = async (body: GetMetricsThresholdRequest, opts?: TRequestOptions): Promise<GetMetricsThresholdResponse>  => {
            return this.httpClient.sendRequest<GetMetricsThresholdResponse>({
                path: '/deliveryProviderPortal/metricsThresholds/get',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public overwriteDraftMenu = async (body: OverwriteDraftMenuRequest, opts?: TRequestOptions): Promise<OverwriteDraftMenuResponse>  => {
            return this.httpClient.sendRequest<OverwriteDraftMenuResponse>({
                path: '/deliveryProviderPortal/overwriteDraftMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public publishMenu = async (body: PublishDraftMenuRequest, opts?: TRequestOptions): Promise<PublishMenuToProvidersResponse>  => {
            return this.httpClient.sendRequest<PublishMenuToProvidersResponse>({
                path: '/deliveryProviderPortal/publishMenu',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public rePublishActiveMenuForProvider = async (body: RePublishActiveMenuForProviderRequest, opts?: TRequestOptions): Promise<RePublishActiveMenuForProviderResponse>  => {
            return this.httpClient.sendRequest<RePublishActiveMenuForProviderResponse>({
                path: '/deliveryProviderPortal/rePublishActiveMenuForProvider',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public removeDineOutOfferingImage = async (body: RemoveDineOutOfferingImageRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/removeDineOutOfferingImage',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public removeMenuEntityImages = async (body: MenuEntityImageRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/removeMenuEntityImages',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public salesByProductGet = async (body: GetSalesByProductRequest, opts?: TRequestOptions): Promise<GetSalesByProductResponse>  => {
            return this.httpClient.sendRequest<GetSalesByProductResponse>({
                path: '/deliveryProviderPortal/salesByProduct/get',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public setDynamicFieldsValues = async (body: SetDynamicFieldsValuesRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/setDynamicFieldsValues',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public storeImprovementTrackEnrollmentAnalyticsEvent = async (body: StoreImprovementTrackAnalyticsEventRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/storeImprovementTrackEnrollmentAnalyticsEvent',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public trackDetailedReportsPageViewed = async (body: TrackDetailedReportsPageViewedRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/trackDetailedReportsPageViewed',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateDineOutOffering = async (body: UpdateDineOutOfferingRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/updateDineOutOffering',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateMenuEntity = async (body: UpdateMenuEntityRequest, opts?: TRequestOptions): Promise<UpdateMenuEntityResponse>  => {
            return this.httpClient.sendRequest<UpdateMenuEntityResponse>({
                path: '/deliveryProviderPortal/updateMenuEntity',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateMenuEntityImage = async (body: UpdateMenuEntityImageMultipart, files: Record<'image', File>, opts?: TRequestOptions): Promise<MenuEntityImageResponse>  => {
            return this.httpClient.sendRequest<MenuEntityImageResponse>({
                path: '/deliveryProviderPortal/updateMenuEntityImage',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                files,
            }, opts);
        }
        public updateMenuItemsDisplayOrder = async (body: UpdateMenuItemsDisplayOrderRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/updateMenuItemsDisplayOrder',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateProviderDetails = async (body: UpdateProviderDetailsRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/updateProviderDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateProviderMenuTimetable = async (body: UpdateProviderMenuTimetableRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/updateProviderMenuTimetable',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateProviderOnboardingDetails = async (body: UpdateProviderOnboardingDetailsRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/updateProviderOnboardingDetails',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateProviderSchedule = async (body: UpdateProviderScheduleRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/updateProviderSchedule',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public uploadDineOutOfferingImage = async (body: UploadDineOutOfferingImage2Multipart, files: Record<'file', File>, opts?: TRequestOptions): Promise<UploadDineOutOfferingImageResponse>  => {
            return this.httpClient.sendRequest<UploadDineOutOfferingImageResponse>({
                path: '/deliveryProviderPortal/uploadDineOutOfferingImage',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                files,
            }, opts);
        }
        public uploadProviderAuthorizationDocument = async (body: UploadProviderAuthorizationDocument2Multipart, files: Record<'file', File>, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/uploadProviderAuthorizationDocument',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                files,
            }, opts);
        }
        public uploadProviderImage = async (body: UploadProviderImage2Multipart, files: Record<'file', File>, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/uploadProviderImage',
                service_id: 'delivery-provider-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                files,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
